import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row mt-2" }
const _hoisted_4 = {
  for: "payInDealSumsEditable",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_5 = { class: "col-sm-8 form-check form-switch d-flex align-items-center" }
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = {
  for: "minPayInDealSum",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_8 = { class: "col-sm-3" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "row mt-2" }
const _hoisted_11 = {
  for: "maxPayInDealSum",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_12 = { class: "col-sm-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.helper.trans('requisites.payInDealSumsEditable')), 1),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.payInDealSumsEditable) = $event)),
              id: "payInDealSumsEditable",
              class: "form-check-input",
              style: {"cursor":"pointer"},
              type: "checkbox",
              role: "switch"
            }, null, 512), [
              [_vModelCheckbox, _ctx.form.payInDealSumsEditable]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.helper.trans("labels.min_pay_in_deal_sum")), 1),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors('minPayInDealSum')
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.minPayInDealSum) = $event)),
                  disabled: _ctx.isMinSumFieldDisabled,
                  class: _normalizeClass([[parentProps.class, {'bg-light': _ctx.isMinSumFieldDisabled}], "form-control"]),
                  "data-maska": "9 99#",
                  "data-maska-tokens": "9:[0-9]:repeated",
                  "data-maska-reversed": "",
                  type: "text",
                  id: "minPayInDealSum"
                }, null, 10, _hoisted_9), [
                  [_vModelText, _ctx.form.minPayInDealSum],
                  [_directive_maska]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.helper.trans("labels.max_pay_in_deal_sum")), 1),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_FormInputWrapper, {
              field: "maxPayInDealSum",
              form: _ctx.componentName
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.maxPayInDealSum) = $event)),
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  "data-maska": "9 99#",
                  "data-maska-tokens": "9:[0-9]:repeated",
                  "data-maska-reversed": "",
                  type: "text",
                  id: "maxPayInDealSum"
                }, null, 2), [
                  [_vModelText, _ctx.form.maxPayInDealSum],
                  [_directive_maska]
                ])
              ]),
              _: 1
            }, 8, ["form"])
          ])
        ])
      ])
    ])
  ]))
}